/**
 * Base class for directive controllers that implements the IController interface.
 */
export class IMRBaseControlDirectiveController implements ng.IController {

    /**
     * Implementing this single method from ng.IController to satisfy the waek types
     * mechanism introduces in TS2.4.
     * More here: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-4.html#weak-type-detection
     */
    public $onInit() { }
}